// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"styles_modalFooter__Ynw3h","reverse":"styles_reverse__qYOzE","grow":"styles_grow__7Mzt_","confirmationText":"styles_confirmationText__Wra_b"};